import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button, { Theme } from '../button/Button';
import { Modal } from '../index';
import CheckBox from '../inputs/CheckBox';

import './ConfirmDeleteModal.scss';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  onDeleteConfirmed: () => void;
  title: string;
  description: string;
  checkboxDescription?: string;
  isDeleteLoading?: boolean;
  cancelLabel?: string;
  confirmLabel?: string;
  confirmButtonTheme?: Theme;
}

const ConfirmDeleteModal: FC<Props> = ({
  isOpen,
  closeModal,
  onDeleteConfirmed,
  title,
  description,
  checkboxDescription,
  isDeleteLoading,
  cancelLabel,
  confirmLabel,
  confirmButtonTheme = Theme.DESTRUCTIVE,
}) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const handleCloseModal = () => {
    closeModal();
    setIsChecked(false);
  };

  useEffect(() => {
    if (isChecked && !isDeleteLoading) {
      handleCloseModal();
    }
  }, [isDeleteLoading]);

  const triggerDelete = () => {
    if (!checkboxDescription || isChecked) {
      onDeleteConfirmed();
    }
  };

  return (
    <Modal className='confirm-delete-modal' title={t(title)} isOpen={isOpen} closeModal={() => closeModal()}>
      <p className='description'>{t(description)}</p>
      {checkboxDescription && (
        <CheckBox
          value='confirmCheckBox'
          isChecked={isChecked}
          name={checkboxDescription}
          onChange={() => setIsChecked(!isChecked)}
        />
      )}
      <div className='buttons'>
        <Button theme={Theme.INVERSE} onClickCallback={handleCloseModal}>
          {t(cancelLabel || 'lblCancel')}
        </Button>
        <Button
          icon={confirmLabel ? undefined : 'Trashcan'}
          theme={confirmButtonTheme}
          onClickCallback={triggerDelete}
          isLoading={isDeleteLoading}
          isDisabled={!!checkboxDescription && !isChecked}>
          {t(confirmLabel || 'lblDelete')}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
